module.exports = __webpack_public_path__ + "img/tablet_active.542d580d.svg";